module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinnerInput"
  }, [_c('div', [_c('div', [_c('mu-icon', {
    attrs: {
      "size": 21,
      "value": _vm.icon
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "numberMiddle"
  }, [_vm._v(_vm._s(_vm.numberValue))])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-187693e9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Recipes/Components/NumberSpinner.vue
// module id = 3063
// module chunks = 1